import { render } from "./CustomerNotes.vue?vue&type=template&id=7470e5a6&scoped=true"
import script from "./CustomerNotes.vue?vue&type=script&lang=js"
export * from "./CustomerNotes.vue?vue&type=script&lang=js"

import "./CustomerNotes.vue?vue&type=style&index=0&id=7470e5a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7470e5a6"]])

export default __exports__